import { Card } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { Content } from "@/features/dashboard/configuracoes/termos/$id/components/TermsContent";

export const Route = createFileRoute("/_private/dashboard/_settings/configuracoes/termos/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Card withBorder shadow="sm" p="lg" mt="md">
      <Content />
    </Card>
  );
}
